import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import QuotesRequestBody from "./QuotesRequestBody";

export default class QuoteService {
  request = new QuotesRequestBody();
  static shared = new QuoteService();

  quotesListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllQuotes(payload.page, payload.size),
          this.request.quotesListRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  } 


  addQuotesRequest = (payload) => {
     return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.addQuotes(),
          this.request.addQuotesRequest(payload, REQUEST_METHOD.POST)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  } 

  editQuotesRequest = (payload) => {
     return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.editQuotes(payload.id),
          this.request.editQuotesRequest(payload, REQUEST_METHOD.PUT)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  } 

  quoteByIdRequest = (payload) => {
    return new Promise((resolve, reject) => { 
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getQuoteById(payload),
          this.request.quoteByIdRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}